<template>
<div class="select-college-wrapper">

  <el-page-header class="head" @back="onBack" content="我的志愿" />

  <el-card class="box-card">
    <el-form :model="form" ref="form" label-width="80px" class="form">
      <el-form-item label="分数"
        prop="score"
        :rules="[
          { type: 'number', message: '分数必须为数字值'}
        ]" >
        <el-input v-model.number="form.score"></el-input>
      </el-form-item>
      
      <el-form-item label="排名"
        prop="rank"
        :rules="[
          { type: 'number', message: '排名必须为数字值'}
        ]"
      >
        <el-input v-model.number="form.rank"></el-input>
      </el-form-item>
      
      <el-form-item label="科目">
        <el-checkbox-group v-model="form.selectedSubjects">
          <template v-for="item in subjects">
            <el-checkbox :key="item.shortName" :label="item.shortName" name="selectedSubjects" />
          </template>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="专业">
        <Search :datas="majors" :searchWord.sync="form.major" placeHolder="请输入专业" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submit">查询</el-button>
      </el-form-item>
    </el-form>

    <!-- 分页导航 -->
    <div class = "pager">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="page.currentPage"
        :page-sizes="[50,100]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="page.totalRecord">
      </el-pagination>
    </div>

    <el-table class="data-table"
      :data="datas"
      style="width: 100%"
      highlight-current-row
      >
      <el-table-column label="大学">
        <template slot-scope="scope">
          <el-link :href="scope.row.website" target="_blank">{{scope.row.college_name}}</el-link>
        </template>
      </el-table-column>
      
      <el-table-column prop="college_code" label="学校代码"></el-table-column>
      <el-table-column prop="major_name" label="专业"></el-table-column>
      <el-table-column prop="major_code" label="专业代码"></el-table-column>
      <el-table-column prop="score" label="分数"></el-table-column>
      <el-table-column prop="rank" label="排名"></el-table-column>
      <el-table-column prop="region" label="区域"></el-table-column>
      <el-table-column prop="grade" label="专业层次"></el-table-column>
      <el-table-column prop="subject_constraint" label="科目限制"></el-table-column>

      <el-table-column label="收藏">
        <template slot-scope="scope">
          <i :class="{selected : scope.row.is_favorite>0}" class="el-icon-star-on" @click="onFavorite(scope.row)"  />
        </template>
      </el-table-column>

    </el-table>

  </el-card>

</div>
</template>

<script>
import {mapState} from 'vuex'
import Search from '@com/common/search'

export default {
  name: 'SelectCollege',
  data () {
    return {
      form:{
        score: 0,
        rank: 0,
        selectedSubjects: [],
        major: ''
      },
      page: {
        pageSize: 10, //每页条数,  默认100条
        totalRecord: 0, //总条数
        totalPage: 0, //总页数
        currentPage:1  //当前显示页码
      },
      datas: [],
      initDatas: []
    }
  },
  computed: {
    // 将vuex中的全局变量subjects映射为组件的局部变量
    ...mapState({
      subjects: 'subjects',
      majors: 'majors',
      userinfo: 'userinfo'
    }),
  },
  components: {
    Search
  },
  methods: {
    submit(){
      const that = this
      that.$refs['form'].validate((valid)=>{
        if(!valid){
          that.$message('查询条件不正确')
          return
        }

        if(that.form.selectedSubjects.length!=3){
          that.$message('需要选择3个科目')
          return
        }

        that.loadData()
      })
    },
    loadData(){
      const that = this
      let params = {
        'currentpage': that.page.currentPage,
        'pagesize': that.page.pageSize,
        'userid': that.userinfo.id
      }
      if(that.form.score>0)
        params['score'] = that.form.score
      if(that.form.rank>0)
        params['rank'] = that.form.rank
      if(that.form.selectedSubjects.length>0){
        let subjectStr = ''
        that.form.selectedSubjects.forEach((e)=>{
          subjectStr += e + ','
        })
        subjectStr = subjectStr.slice(0, subjectStr.length-1)
        params['subjects'] = subjectStr
      }
      if(that.form.major.length>0)
        params['majors'] = that.form.major
      
      that.axios.get('/homepage/selectcollege/querylistbypage', {params})
      .then((ret)=>{
        let {code,message,data} = ret
        if(code===0){
          that.datas = data.list
          that.initDatas = JSON.parse(JSON.stringify(that.datas))

          that.page.totalRecord = data.totalRecord  //总条数
          that.page.totalPage = data.pagePage    //总页数
        }else{
          that.$message('查询失败')
          that.$message(message)
        }
      })
    },
    onFavorite(row){
      row.is_favorite = row.is_favorite == 0 ? 1 : 0 
      this.saveFavorite()
    },
    saveFavorite(){
      const that = this

      let changedRows = []
      that.datas.forEach((item,index)=>{
        if(that.initDatas[index].is_favorite != item.is_favorite)
          changedRows.push(item)
      })

      if(changedRows.length==0)
        return

      let jsonStr = JSON.stringify(changedRows)
      const params = new FormData()
      params.append('userid', that.userinfo.id)
      params.append('json', jsonStr)

      that.axios.post('/homepage/selectcollege/savefavorites', params)
      .then((ret)=>{
        let {code,message} = ret
        if(code===0){
          that.initDatas = JSON.parse(JSON.stringify(that.datas))
          that.$message('保存成功')
        }else{
          that.$message('查询失败')
          that.$message(message)
        }
      })
    },
    // 修改每页记录数
    sizeChange(val) {
      this.page.pageSize = val
      this.loadData()
    },
    //翻页
    currentChange(val) {
      this.page.currentPage=val
      this.loadData()
    },
    onBack(){
      this.$router.back()
    },
  }
}
</script>

<style lang="stylus" scoped>
.select-college-wrapper
  margin: 40px 40px 50px 40px
  .head
    margin-bottom: 20px
  .form
    width: 40%
  .data-table
    >>> .el-icon-star-on
      font-size: 20px
      color: #bbbbbb
    .selected
      color: red
</style>
